import React, { useContext, useEffect, useState } from "react";
import appConst from "../Utilities/appConst.json";
import "../styles/basketItemDiscount.css";
import { LanguageContext } from "../context/language/LanguageContext";
import SummaryItemDiscountDetails from "./SummaryBasketItemDiscountDetails";
import SummaryBasketItemDefaultDetails from "./SummaryBasketItemTileDefaultDetails";
import { colorMap, materialMap, sizeMap } from "../Utilities/mapUtil";
import SummaryItemCalendarDefaultDetails from "./SummaryItemCalendarDefaultDetails";
import SummaryItemBookDefaultDetails from "./SummaryItemBookDefaultDetails";
import { getUiItemFilterPrefix } from "../Utilities/itemFilter";

const SummaryItemDetails = (props) => {
  const languageContext = useContext(LanguageContext);
  const product = sessionStorage.getItem(appConst.PRODUCT);
  const detailsItemId = props.couponsItem?.item_id ?? props.id ?? "unknown";

  const [title, setTitle] = useState();
  const [classes, setClasses] = useState("summary_details");
  const [mosaicHeight, setMosaicHeight] = useState(0);
  const [mosaicWidth, setMosaicWidth] = useState(0);

  const discounts =
    props.couponsItem?.discount > 0
      ? props.couponsItem?.discount * props.couponsItem?.quantity
      : 0;
  const priceAndQuantityText = props.couponsItem
    ? `₪${parseFloat(props.couponsItem?.item_q1_price).toFixed(2)} X ${
        props.couponsItem?.quantity
      }`
    : "";

  useEffect(() => {
    switch (product) {
      case appConst.TILES:
        if (props.isMosaic) {
          setMosaicHeight(calcMosaicLength(props.heightQuantity));
          setMosaicWidth(calcMosaicLength(props.widthQuantity));
          setTitle(
            languageContext.getTranslation(appConst.MOSAIC) +
              " " +
              props.heightQuantity +
              "X" +
              props.widthQuantity +
              " " +
              languageContext.getTranslation(appConst.SQUARES)
          );
        } else {
          setTitle(
            languageContext.getTranslation(
              appConst.SQUARED_LUPA +
                "_" +
                materialMap.get(props.couponsItem.material)
            )
          );
        }
        break;
      case appConst.BOOKS: {
        const itemFilterPrefix = getUiItemFilterPrefix(props.couponsItem?.item_filter);
        if (itemFilterPrefix === appConst.VERSION_CALENDAR_PREFIX) {
          setTitle(props.couponsItem.title);
        } else {
          setTitle(
            languageContext.getTranslation(appConst.ALBUM) +
              " " +
              props.couponsItem.title
          );
        }
        break;
      }
      case appConst.CALENDARS:
        setTitle(props.couponsItem.title);
        break;
    }
  }, [props.couponsItem.material, props.heightQuantity, props.widthQuantity]);

  useEffect(() => {
    discounts
      ? setClasses("position_flex_col_space_between")
      : setClasses("summary_details");
  }, [discounts]);

  const calcMosaicLength = (quantity) => {
    return (
      appConst.TAIL_SIZE * quantity +
      (quantity - 1) * appConst.SCALE_SIZE
    ).toFixed(1);
  };

  const renderComponent = (product) => {
    switch (product) {
      case appConst.TILES:
        return (
          <SummaryBasketItemDefaultDetails
            isMosaic={props.isMosaic}
            subTitle={
              languageContext.getTranslation(appConst.MEASURES) +
              ": " +
              mosaicHeight +
              "X" +
              mosaicWidth +
              " " +
              languageContext.getTranslation(appConst.CM)
            }
            format={props.couponsItem.format}
            sizePlaceholder={languageContext.getTranslation(
              sizeMap.get(props.couponsItem.format)
            )}
            colorPlaceholder={languageContext.getTranslation(
              colorMap.get(props.couponsItem.fram_color)
            )}
          />
        );
      case appConst.BOOKS:
        const itemFilterPrefix = getUiItemFilterPrefix(
          props.couponsItem?.item_filter
        );

        if (itemFilterPrefix !== appConst.VERSION_CALENDAR_PREFIX) {
          return <SummaryItemBookDefaultDetails item={props.couponsItem} />;
        } else {
          return <SummaryItemCalendarDefaultDetails item={props.couponsItem} />;
        }
      case appConst.CALENDARS:
        return <SummaryItemCalendarDefaultDetails item={props.couponsItem} />;
    }
  };

  return (
    <div data-testid={`summary-item-details-${detailsItemId}`}>
      <div
        className="summary_item_title"
        style={{ paddingBottom: "0.5rem", display: "flex", justifyContent: "space-between" }}
        data-testid={`summary-item-title-row-${detailsItemId}`}
      >
        <h3 data-testid={`summary-item-title-${detailsItemId}`}>{title}</h3>
        <h3 data-testid={`summary-item-price-quantity-${detailsItemId}`}>{priceAndQuantityText}</h3>
      </div>

      <div className={classes} data-testid={`summary-item-content-${detailsItemId}`}>
        <div className="summary_details_default" data-testid={`summary-item-default-details-${detailsItemId}`}>
          {renderComponent(product)}
        </div>

        <SummaryItemDiscountDetails
          discounts={props.discounts} //{10 > 0 ? parseFloat(10).toFixed(2) : null} // test
          isMosaic={props.isMosaic}
          itemId={detailsItemId}
        />
      </div>
    </div>
  );
};
export default SummaryItemDetails;
